import { ReactElement, ReactNode } from 'react'
import { tooltipClasses } from '@mui/material'
import { BootstrapTooltip } from '../../../view/components/tooltips/Tooltip/BootStrapToopTip'
import { colorPalette } from '../../../view/style/colorPalette'
import { PreviewAnchor } from './useWbsItemSearchPreview'

// 値クリックで出す遷移先プレビューのTooltip。childrenではなくanchorElの位置に表示する。
//
// 見た目（最大幅・枠線・矢印の枠線）はデモの使用不可Tooltip
// （layout/DemoDisabledAction.tsx）に揃えている。あちらは他画面と共有する
// レビュー済みのファイルなので共通化はせず、ここで同じ指定を持つ。
// どちらかの見た目を変える場合は、もう一方も合わせること。
type WbsItemSearchPreviewTooltipProps = {
  title: ReactNode
  children: ReactElement
  open: boolean
  anchorEl: PreviewAnchor | null
}

const TOOLTIP_MAX_WIDTH = 360

const TOOLTIP_BORDER_COLOR = colorPalette.monotone[2]

export const WbsItemSearchPreviewTooltip = ({
  title,
  children,
  open,
  anchorEl,
}: WbsItemSearchPreviewTooltipProps) => {
  return (
    <BootstrapTooltip
      arrow={true}
      open={open}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: TOOLTIP_MAX_WIDTH,
            border: `1px solid ${TOOLTIP_BORDER_COLOR}`,
            [`& .${tooltipClasses.arrow}::before`]: {
              borderBottom: `1px solid ${TOOLTIP_BORDER_COLOR}`,
              borderRight: `1px solid ${TOOLTIP_BORDER_COLOR}`,
            },
          },
        },
        popper: anchorEl ? { anchorEl } : undefined,
      }}
      title={title}
    >
      {children}
    </BootstrapTooltip>
  )
}
